module.exports = __webpack_public_path__ + "images/emoji/large_blue_diamond.9222603c0f91ebf5f91d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/large_blue_diamond.png
// module id = lHyr
// module chunks = 24